import Cookies from "js-cookie";

function initAlertBar() {
  const alertBar = document.querySelector(".alert-bar .alert") as HTMLDivElement;
  if (!alertBar) return;

  const alertBarParagraph = alertBar.querySelector("p");
  const noticeText = alertBarParagraph?.dataset.noticeText?.trim() || "";
  const hashCode = (str: string) =>
    Array.from(str).reduce((hash, char) => (hash << 5) - hash + char.charCodeAt(0), 0);
  const cookieKey = `cpaws-alert-${hashCode(noticeText)}`;

  if (Cookies.get(cookieKey) !== "true") {
    alertBar.classList.remove("is-hidden");
  } else if (Cookies.get(cookieKey) === "true") {
    alertBar.classList.add("is-hidden");
  }

  const closeButton = alertBar.querySelector(".alert-dismiss");
  if (closeButton) {
    closeButton.addEventListener("click", () => {
      alertBar.classList.add("is-hidden");
      Cookies.set(cookieKey, "true", { expires: 3 });
    });
  }
}

initAlertBar();
